import { render, staticRenderFns } from "./edit1.vue?vue&type=template&id=15307961&scoped=true"
import script from "./edit1.vue?vue&type=script&lang=js"
export * from "./edit1.vue?vue&type=script&lang=js"
import style0 from "./edit1.vue?vue&type=style&index=0&id=15307961&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15307961",
  null
  
)

export default component.exports